import { __awaiter, __rest } from "tslib";
import AjaxUtils from './ajaxUtils';
const SERVER = envConfig.OUTBOUND_SERVER_URL;
const createURL = (queryStringParams, integrationName) => Object.entries(queryStringParams).reduce((currentURL, [key, value]) => (value ? `${currentURL}&${key}=${encodeURIComponent(value)}` : currentURL), `/v2/account-integrations-save-to?integrationName=${integrationName}`);
const saveToIntegrationBuilder = integrationName => (options) => __awaiter(void 0, void 0, void 0, function* () {
    const { contact } = options, queryStringParams = __rest(options, ["contact"]);
    const url = createURL(queryStringParams, integrationName);
    return AjaxUtils.post(url, contact);
});
const saveToSalesforce = saveToIntegrationBuilder('salesforce');
const saveToZoho = saveToIntegrationBuilder('zoho');
const saveToHubspot = saveToIntegrationBuilder('hubspot');
const saveToOutreach = saveToIntegrationBuilder('outreach');
const saveToSalesloft = saveToIntegrationBuilder('salesloft');
const saveToPipedrive = saveToIntegrationBuilder('pipedrive');
const getOutreachSequences = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = '/v2/account-integrations-save-to/outreach?objectName=sequence';
        return AjaxUtils.get(url);
    }
    catch (e) {
        return undefined;
    }
});
const getSalesloftCadences = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = '/v2/account-integrations-save-to/salesloft?objectName=cadences';
        return AjaxUtils.get(url);
    }
    catch (e) {
        return undefined;
    }
});
const getAccountIntegrations = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return AjaxUtils.get(`${SERVER}/v2/account-integrations?$eager=integration&fetchTokenInfo=true`, true);
    }
    catch (e) {
        return undefined;
    }
});
const getAccountIntegrationsAdvancedSettings = (integrationNames) => __awaiter(void 0, void 0, void 0, function* () { return AjaxUtils.post('/api/v1/lusha-integrations/account-integrations-advanced-settings', { integrationNames }); });
const getUserAllActiveIntegrations = () => __awaiter(void 0, void 0, void 0, function* () { return AjaxUtils.get('/api/v1/lusha-integrations/all-user-active-integrations'); });
const searchCompaniesInCrm = (payload) => __awaiter(void 0, void 0, void 0, function* () { return AjaxUtils.post('/api/v1/lusha-integrations/companies/crm-search', payload); });
const searchContactsInCrm = (payload) => __awaiter(void 0, void 0, void 0, function* () { return AjaxUtils.post('/api/v1/lusha-integrations/contacts/crm-search', payload); });
export { getAccountIntegrations, getAccountIntegrationsAdvancedSettings, getOutreachSequences, getSalesloftCadences, getUserAllActiveIntegrations, saveToHubspot, saveToOutreach, saveToPipedrive, saveToSalesforce, saveToSalesloft, saveToZoho, searchCompaniesInCrm, searchContactsInCrm, };
